import { useCallback, useMemo } from 'react';
import type { FC } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import type { MainMenuGroupType } from '@n3/pn-declaration';
import { useComponents } from '@n3/pn-core';
import { getCookie } from 'tiny-cookie';
import { API } from '@/constants/api';

export const EiopHeader: FC = () => {
  const { Header: HeaderComponent } = useComponents();

  //FIXME: отображать реальное состояние авторизации
  const userProfile = getCookie('Authorization-Token');
  const location = useLocation();
  const { pathname } = location;

  const history = useHistory();

  const onSearchSubmit = useCallback(
    (searchValue: string) => {
      history.push(`/search/?search=${encodeURIComponent(searchValue)}`);
    },
    [history]
  );

  const hasSearchInput = !pathname.startsWith('/search/');

  const eiopBaseUrl = API.EIOPUrl?.substr(0, API.EIOPUrl.length - 1);

  const mainMenuGroups = useMemo<MainMenuGroupType[]>(
    () => [
      {
        icon: eiopBaseUrl + '/static/eiop/header/operators.svg',
        label: 'Операторам системы',
        links: [
          {
            label: 'Операторам',
            url: eiopBaseUrl + '/operator/',
            isSimpleLink: true,
          },
        ],
      },

      {
        icon: eiopBaseUrl + '/static/eiop/header/news.svg',
        label: 'Актуальные новости',
        links: [
          {
            label: 'Все новости',
            url: eiopBaseUrl + '/news/',
            isSimpleLink: true,
          },
        ],
      },
      {
        icon: eiopBaseUrl + '/static/eiop/header/events.svg',
        label: 'События и мероприятия',
        links: [
          {
            label: 'Ближайшие события',
            url: eiopBaseUrl + '/events/',
            isSimpleLink: true,
          },
        ],
      },

      {
        icon: eiopBaseUrl + '/static/eiop/header/competitions.svg',
        label: 'Конкурсы',
        links: [
          {
            label: 'Конкурсы для детей',
            url: 'https://olimp-obr.lenreg.ru/competitions',
            target: '_blank',
            isSimpleLink: true,
          },

          {
            label: 'Конкурсы для педагогов',
            url: 'https://konkurs-obr.lenreg.ru/competitions',
            target: '_blank',
            isSimpleLink: true,
          },

          {
            label: 'Отчёты конкурсов для детей',
            url: 'https://olimp-obr.lenreg.ru/monitoring',
            target: '_blank',
            isSimpleLink: true,
          },

          {
            label: 'Отчёты конкурсов для педагогов',
            url: 'https://konkurs-obr.lenreg.ru/monitoring',
            target: '_blank',
            isSimpleLink: true,
          },
        ],
      },

      {
        icon: eiopBaseUrl + '/static/eiop/header/rboo.svg',
        label: 'Образовательные организации',
        links: [
          {
            label: 'Все организации',
            url: eiopBaseUrl + '/education/',
            isSimpleLink: true,
          },
        ],
      },

      {
        icon: eiopBaseUrl + '/static/eiop/header/resources.svg',
        label: 'Информационные ресурсы',
        links: [
          {
            label: 'Контакты',
            url: eiopBaseUrl + '/contacts/',
            isSimpleLink: true,
          },
        ],
      },

      {
        icon: eiopBaseUrl + '/static/eiop/header/faq.svg',
        label: 'Часто задаваемые вопросы',
        links: [
          {
            label: 'Все вопросы',
            url: eiopBaseUrl + '/faq/',
            isSimpleLink: true,
          },
        ],
      },
    ],
    [pathname]
  );

  return (
    <HeaderComponent
      groups={mainMenuGroups}
      hasSearchInput={hasSearchInput}
      isAuthorized={!!userProfile}
      onSearchSubmit={onSearchSubmit}
    />
  );
};
